import React from 'react';
import Qualifications from './Qualifications'; // Adjust the import path accordingly
import './Portfolio.css'; // Add CSS import

const Portfolio = () => {
  return (
    <div className="portfolio-container">
      {/* Other sections/components of your portfolio */}
      <Qualifications />
      {/* Other sections/components of your portfolio */}
    </div>
  );
};

export default Portfolio;
